import { HttpError, useOne, useTranslation } from "@refinedev/core";
import { Label } from "components/label";
import { SwitchButton } from "components/switchButton";
import {
  IAdditionalSetupData,
  IEventIdsItem,
  ISimpleEventDetail,
  PrivateFlowVerifyType,
  UserType,
} from "interfaces";
import { PRIVATE_FLOW_VERIFY_TYPES } from "utills/constants";
import { canAccessByType, formatNumber } from "utills/helpers";

export const PrivateFlow = ({
  additionalSetupData,
}: {
  additionalSetupData: IAdditionalSetupData | null;
  eventDetailData: ISimpleEventDetail;
}) => {
  const { translate } = useTranslation();
  const { data, isFetching: isFetchingEvents } = useOne<
    IEventIdsItem[],
    HttpError
  >({
    resource: "content/dropdown/events?v=2",
    id: "",
    meta: {
      resource: "data",
    },
    queryOptions: {
      enabled: !!(additionalSetupData?.private_flow?.sync_enabled && canAccessByType(UserType.ADMIN)),
    } as any,
  });

  const eventIds = (data?.data ?? []).map((event: IEventIdsItem) => ({
    value: event.id,
    label: event.name_en,
  }));

  return (
    <div className="box-container p-4 text-sm sm:p-6">
      <div className="grid gap-x-4 gap-y-6 sm:grid-cols-6 lg:gap-x-6">
        <div className="col-span-full">
          <Label
            required
            id="private_flow.verify_type"
            name={translate(
              "eventSetup.additionalSetup.privateFlow.verifyType"
            )}
          />
          {
            PRIVATE_FLOW_VERIFY_TYPES.find(
              (selected: { label: string; value: any }) =>
                selected.value ===
                additionalSetupData?.private_flow?.verify_type
            )?.label
          }
        </div>
        {/* <div className="sm:col-span-3">
          <Label
            required
            id="private_flow.usage_count"
            name={translate("eventSetup.additionalSetup.privateFlow.usageCount")}
          />
          {additionalSetupData?.private_flow?.usage_count}
        </div> */}
        {additionalSetupData?.private_flow?.verify_type ===
        PrivateFlowVerifyType.DOMAIN_EMAIL ? (
          <div className="col-span-full">
            <Label
              required
              id="private_flow.email_domain"
              name={translate(
                "eventSetup.additionalSetup.privateFlow.inputEmailDomain"
              )}
            />
            <div className="whitespace-pre-wrap">
              {additionalSetupData?.private_flow.email_domain}
            </div>
          </div>
        ) : (
          <></>
        )}
        {canAccessByType(UserType.ADMIN) && (
          <>
            <div className="col-span-full">
              <SwitchButton
                disabled
                checked={
                  additionalSetupData?.private_flow?.sync_enabled ?? false
                }
                onChange={() => {}}
                label="Sync Order Code"
              />
            </div>
            {additionalSetupData?.private_flow?.sync_enabled && (
              <>
                <div className="sm:col-span-3">
                  <Label
                    required
                    id="private_flow.usage_count"
                    name={translate(
                      "eventSetup.additionalSetup.privateFlow.usageCount"
                    )}
                  />
                  <p>
                    {formatNumber(
                      additionalSetupData?.private_flow?.usage_count
                    )}
                  </p>
                </div>
                <div className="sm:col-span-3">
                  <Label
                    id="private_flow.passcode_source_event_ids"
                    name="Events"
                    required
                  />
                  <div>
                    {(
                      additionalSetupData?.private_flow
                        ?.passcode_source_event_ids ?? []
                    ).map((eventId) => (
                      <p>
                        {
                          eventIds.find((event) => event.value === eventId)
                            ?.label
                        }
                      </p>
                    ))}
                  </div>
                </div>
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
};
